export { ServedLocations } from './served-locations';
